class User {
	private _uuid: string;
	firstName: string;
	lastName: string;
	found: boolean;
	photo: string;
	premium: boolean

	constructor(
		uuid: string,
		firstName: string,
		lastName: string,
		found: boolean,
		photo: string,
		premium: boolean
	) {
		this._uuid = uuid;
		this.firstName = firstName;
		this.lastName = lastName;
		this.found = found
		this.photo = photo;
		this.premium = premium
	}

	get uuid(): string {
		return this._uuid;
	}


}

export default User;
